var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrierReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16671 11.6665V14.9998M13.8334 9.99984V14.9998M10.5 6.6665V14.9998M17.1667 5.6665V14.3332C17.1667 15.7333 17.1667 16.4334 16.8942 16.9681C16.6545 17.4386 16.2721 17.821 15.8017 18.0607C15.2669 18.3332 14.5668 18.3332 13.1667 18.3332H7.83337C6.43324 18.3332 5.73318 18.3332 5.1984 18.0607C4.72799 17.821 4.34554 17.4386 4.10586 16.9681C3.83337 16.4334 3.83337 15.7333 3.83337 14.3332V5.6665C3.83337 4.26637 3.83337 3.56631 4.10586 3.03153C4.34554 2.56112 4.72799 2.17867 5.1984 1.93899C5.73318 1.6665 6.43324 1.6665 7.83337 1.6665H13.1667C14.5668 1.6665 15.2669 1.6665 15.8017 1.93899C16.2721 2.17867 16.6545 2.56112 16.8942 3.03153C17.1667 3.56631 17.1667 4.26637 17.1667 5.6665Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierReport);
export default __webpack_public_path__ + "static/media/carrier-report.ae724369baec4f81eca390f4db8b9b0e.svg";
export { ForwardRef as ReactComponent };